<div class="search-result-container">
  <app-mobile-header [title]="'label.search'" [manualBackEvent]="true"
    (onManualBackEvent)="onClickBack()"></app-mobile-header>

  <app-search-filter [inputSearchValue]="searchInput" [recentSearch]="recentSearch" [routeSearchText]="routeSearchText"
    (clearSearchInput)="clearSearchField()" (outputSearchStore)="outputSearchStore($event)"
    (outputRecentSearch)="outputRecentSearch()"></app-search-filter>

  <div *ngIf="showMobileSelection">
    <div class="recentSearch-container" *ngIf="recentSearch && recentSearch.length > 0">
      <div class="recentSearch-header">
        <h1>{{'label.recent' | translate}}</h1>
        <app-button [blackTextButton]="true" [iconName]="'icon-delete'" (onClickEvent)="ondelete()" class="recentAction-btn"></app-button>
      </div>

      <div class="recent-list" *ngFor="let searchText of recentSearch; let i = index">
        <div class="recent-searchText">
          <h1 (click)="onRecentClick(searchText)">{{ searchText }}</h1>
          <app-button [blackTextButton]="true" [iconName]="'icon-times'" (onClickEvent)="removeRecentRecord(i); $event.stopPropagation()"
            class="deleteRecent-btn" class="recentAction-btn"></app-button>
        </div>
      </div>
    </div>

    <div class="hotSearch-container">
      <h1>{{'suggestions' | translate}}</h1>
      <div class="hotSearch-content" *ngIf="cuisines && cuisines.length > 0">
        <div class="hotSearc-list" *ngFor="let itm of cuisines" (click)="onRecentClick(itm)">
          {{itm}}
        </div>
      </div>
    </div>
  </div>

  <div class="searching-result-container" *ngIf="storesData && storesData.length !== 0" [hidden]="showMobileSelection">
    <div class="totalResult-heading">{{totalSearchResult }} {{resultSearchText}} {{'label.found' |
      translate}}
    </div>
    <app-sort [sortList]="searchSortList" [currentFilter]="sortList.label" [dropdownRight]="true"
      (outputSorting)="outputSorting($event)">
    </app-sort>
  </div>

  <div class="empty-searching" *ngIf="storesData && storesData.length == 0" [hidden]="showMobileSelection">
    <img src="assets/generalImage/not_found.svg" alt="image">
    <h1 [innerHTML]="'error.couldnt.find.text.try.something.else' | translate: { seachText : resultSearchText }"></h1>
    <app-button [buttonName]="'button.retry' | translate"
      (onClickEvent)="onClickSearchAgain()" class="searchAgain-btn"></app-button>
  </div>

  <div class="searched-itemCard" *ngIf="storesData && storesData.length > 0" [hidden]="showMobileSelection">
    <div *ngFor="let storeData of storesData last as isLast">
      <app-mobile-item-card-channel-stores [storeData]="storeData" [showStoreNearBy]="true"
        (click)="onClickItemCard(storeData)" [searchResult]="true"></app-mobile-item-card-channel-stores>
    </div>
  </div>
</div>

<p-dialog position="bottom" *ngIf="displayStoreDialog" [(visible)]="displayStoreDialog" [modal]="true"
  [dismissableMask]="true" [blockScroll]="true" styleClass="displayStoreDialog-dialog">
  <app-nearby-store [storeList]="storeData.otherStores" [currency]="currency" [currentCart]="cartModel">
  </app-nearby-store>
</p-dialog>
